import type { StrictLocaleObject } from '../../i18n/shared/locales'

/**
 * The three query params every storefront GraphQL call carries, resolved from
 * a locale. `localeCode` picks the Vendure channel token on the server
 * (`server/utils/headers.ts`); `languageCode` and `currencyCode` are forwarded
 * to Vendure as they are (`server/utils/makeGraphqlRequest.ts`).
 *
 * The graphql-config plugin stamps these for the ACTIVE locale on every call.
 * Exported so a caller can address ANOTHER locale's channel without reloading
 * the app: exalted's checkout moves a cart into the channel that serves the
 * destination the customer picked (`useCheckoutChannelSwitch`).
 */
export function localeRequestParams(locale: StrictLocaleObject | null | undefined) {
  return {
    localeCode: locale?.code ?? 'en',
    // Vendure's LanguageCode for European Portuguese is `pt_PT`, not `pt`.
    languageCode: locale?.code === 'pt' ? 'pt_PT' : ((locale?.language ?? 'en').split('-')[0] ?? 'en'),
    currencyCode: locale?.currency ?? 'USD',
  }
}
